<div class="checkemail text-center">
  <p>
    Please check your email to activate your account.<br />
    This can take a few minutes.
  </p>
  <img class="rounded" src="assets/img/youve-got-mail.gif" alt="Email sent" />
</div>
